import React, { useState } from "react";

const CoverPanel = () => {
  const [state, setState] = useState({
    showFullCar: false,
    showSwiftFullPic: false,    
    showFullBasket: false,
    showFullGlass: false,
  });

  const onHoverCar = (value) => {
    setState({ ...state, showFullCar: value });
  };

  const onHoverSwiftCar = (value) => {
    setState({ ...state, showSwiftFullPic: value });
  };

  const onHoverBasket = (value) => {
    setState({ ...state, showFullBasket: value });
  };

  const onHoverGlass = (value) => {
    setState({ ...state, showFullGlass: value });
  };

  const {    
    showFullCar,
    showSwiftFullPic,
    showFullBasket,
    showFullGlass,    
  } = state;
  return (
    <div className="cover-wrapper">
      <div className="h-100 row cover-panel">
        <div className="col-md-4 col-xs-12 p-0">
      
            <div className="row cover-panel">
              <div
                className={`col p-0 cover-pic-1 ${showFullCar ? 'showFullCar': ''} ${showSwiftFullPic ? 'd-none': 'd-block'}`}
                onMouseOver={() => onHoverCar(true)}
                onMouseLeave={() => onHoverCar(false)}
              ></div>
              <div
                className={`col p-0 cover-pic-2 ${showSwiftFullPic ? 'showSwiftFullPic': ''} ${showFullCar ? 'd-none': 'd-block'}`}
                onMouseOver={() => onHoverSwiftCar(true)}
                onMouseLeave={() => onHoverSwiftCar(false)}
              ></div>
            </div>
            
        </div>
        <div className="col-md-4 col-xs-12 p-0 center-cover">
          <div className="center-text">
            <h1 className="poppins-bold font-size-60">BEElieve us</h1>
            <div className="font-size-40">you are choosing</div>
            <h1 className="poppins-bold font-size-100">RIGHT!</h1>
          </div>
        </div>
        <div className="col-md-4 col-xs-12 p-0">
            <div className="row cover-panel">
              <div
                className={`col p-0 cover-pic-3 full-cover-pic4 ${showFullBasket ? 'showFullBasket': ''} ${showFullGlass ? 'd-none': 'd-block'}`}
                onMouseOver={() => onHoverBasket(true)}
                onMouseLeave={() => onHoverBasket(false)}
              ></div>
              <div
              className={`col p-0 cover-pic-4 ${showFullGlass ? 'showFullGlass': ''} ${showFullBasket ? 'd-none': 'd-block'}`}

                onMouseOver={() => onHoverGlass(true)}
                onMouseLeave={() => onHoverGlass(false)}
              ></div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default CoverPanel;
